// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const closedDrawerWidth = 113;
export const appDrawerWidth = 320;
